<template>
  <v-form class='createPrefixForm' v-model='valid' ref='createPrefixForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='prefix.prefix'
            :error-messages='error.prefix'
            label='Prefix'
            placeholder='Prefix'
            autofocus
            ref="firstInput"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-autocomplete
            v-model="prefix.module"
            item-value="id"
            :items="[{id: 'wps_aws', text: 'WPS AWS'}, {id: 'wps_asme', text: 'WPS ASME'}, {id: 'pqr_aws', text: 'PQR AWS'}, {id: 'pqr_asme', text: 'PQR ASME'}, {id: 'project', text: 'Project'}, {id: 'machine', text: 'Machine'}]"
            :error-messages='error.module'
            label="Module"
            placeholder='Module'
          ></v-autocomplete>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Is Default</label>
          <v-radio-group v-model="prefix.is_default" row>
            <v-radio label="No" :value="0" class="mt-0"></v-radio>
            <v-radio label="Yes" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="prefix.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      this.$axios.post('getPrefixById/' + id).then((res) => {
        this.prefix = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      prefix: { status: 0, is_default: 0 },
      error: {},
    }
  },
  methods: {
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'savePrefix/' + this.edit_id : 'savePrefix'
        this.$axios.post(route, this.prefix).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/prefix')
          } else {
            this.reset()
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createPrefixForm.validate()
      }
    },
    reset () {
      this.$refs.createPrefixForm.reset()
      setTimeout(() => {
        this.prefix = { status: 0, is_default: 0 }
        this.error = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
  },
}
</script>

<style>
.createPrefixForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createPrefixForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
